var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h4", [_vm._v("Статистика рецептов")]),
            _vm._v(" "),
            _c("table", { staticClass: "table table-hover" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.records, function (record, index) {
                  return _c("tr", [
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          index +
                            1 +
                            (_vm.paginator.current_page - 1) *
                              _vm.paginator.per_page
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(record.prep_id))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(record.prep.prep))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(record.doctor.name) +
                          " (" +
                          _vm._s(record.doctor.specialty) +
                          ")"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(record.client.name) +
                          " " +
                          _vm._s(record.client.surname)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(record.template_date))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(record.template_number))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(record.created_at))]),
                  ])
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _vm.paginator
                  ? _c("paginate", {
                      attrs: {
                        "page-count": _vm.paginator.last_page,
                        "page-range": 3,
                        "margin-pages": 2,
                        "click-handler": _vm.getStatistic,
                        "prev-text": "&laquo",
                        "next-text": "&raquo",
                        "container-class": "pagination",
                        "prev-class": "page-item",
                        "prev-link-class": "page-link",
                        "page-class": "page-item",
                        "page-link-class": "page-link",
                        "next-class": "page-item",
                        "next-link-class": "page-link",
                        "active-class": "active green_btn",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Врач")]),
        _vm._v(" "),
        _c("th", [_vm._v("Клиент")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата рецепта")]),
        _vm._v(" "),
        _c("th", [_vm._v("Номер рецепта")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата создания")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }